import { render, staticRenderFns } from "./PurchasesInvoicesPanel.vue?vue&type=template&id=50ff8c26&scoped=true"
import script from "./PurchasesInvoicesPanel.vue?vue&type=script&lang=js"
export * from "./PurchasesInvoicesPanel.vue?vue&type=script&lang=js"
import style0 from "./PurchasesInvoicesPanel.vue?vue&type=style&index=0&id=50ff8c26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ff8c26",
  null
  
)

export default component.exports